var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.883 26.4667L19.883 26.4666L19.8779 26.4683C19.6839 26.5296 19.4512 26.5024 19.2491 26.3812L19.2351 26.3728L19.2205 26.3653L10.7155 21.9915L10.4871 21.874L10.2585 21.9913L1.74036 26.3652L1.74029 26.365L1.72937 26.371C1.59146 26.4462 1.44881 26.4855 1.32562 26.4855C0.886231 26.4855 0.5 26.1082 0.5 25.6085V5.1163C0.5 3.43178 1.15169 2.31018 2.17456 1.59004C3.2236 0.851479 4.71561 0.5 6.43125 0.5H14.5294C16.2516 0.5 17.7439 0.851474 18.7965 1.59042C19.823 2.31113 20.4813 3.43394 20.5 5.11904V25.6085C20.5 25.7627 20.4646 25.912 20.3993 26.0384C20.2897 26.2458 20.1069 26.3984 19.883 26.4667ZM15.4219 7.65368H5.53875C4.68098 7.65368 4.015 8.36759 4.015 9.22014C4.015 10.0709 4.68058 10.7866 5.53875 10.7866H15.4219C16.28 10.7866 16.9456 10.0709 16.9456 9.22014C16.9456 8.36759 16.2796 7.65368 15.4219 7.65368Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.4b5f95fff5e551df2f280753c4a26c04.svg";
export { ForwardRef as ReactComponent };